export var EARN = "EARN";
export var SPEND = "SPEND";
